import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import { NavLink as RouterLink } from 'react-router-dom';
import { Search as SearchIcon } from '@mui/icons-material';
import {
    Box, Button, Card,
    CardContent, TextField,
    InputAdornment, Grid
} from '@mui/material';

const useStyles = makeStyles((theme) => ({
    root: {},
    importButton: {
        marginRight: theme.spacing(1)
    },
    exportButton: {
        marginRight: theme.spacing(1)
    },
    selectWidth: {
        width: '100%'
    }
}));

function Toolbar({
    className,
    inputValue,
    pagedObject,
    onPressButton,
    handleChange,
    inputLabel = '',
    ...rest
}) {
    const classes = useStyles();
    return (
        <div className={clsx(classes.root, className)} {...rest}>
            <Box display="flex" justifyContent="flex-end">
                <Button
                    color="primary"
                    variant="contained"
                    component={RouterLink}
                    to={"/notificacoes/cadastrar"}
                >
                    Adicionar notificação
                </Button>
            </Box>
            <Box mt={3}>
                <Card>
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item md={6} xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item md={12} xs={12}>
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <LoadingButton variant="contained" onClick={onPressButton}>
                                                            <SearchIcon fontSize="small" color="white" />
                                                        </LoadingButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                            placeholder={"Buscar por notificação"}
                                            variant="outlined"
                                            label={inputLabel}
                                            value={inputValue}
                                            onChange={(e) => handleChange("searchTerm", e.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string,
    inputValue: PropTypes.string.isRequired,
    pagedObject: PropTypes.object.isRequired,
    onPressButton: PropTypes.func.isRequired,
    inputLabel: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
};

export default Toolbar;